import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map as map$1 } from 'rxjs';
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType[ContentType["CONTENT_TYPE_HTML"] = 0] = "CONTENT_TYPE_HTML";
  ContentType[ContentType["CONTENT_TYPE_TEXT"] = 1] = "CONTENT_TYPE_TEXT";
  return ContentType;
}(ContentType || {});
var NotificationMedium = /*#__PURE__*/function (NotificationMedium) {
  NotificationMedium[NotificationMedium["NOTIFICATION_MEDIUM_WEB"] = 0] = "NOTIFICATION_MEDIUM_WEB";
  NotificationMedium[NotificationMedium["NOTIFICATION_MEDIUM_EMAIL"] = 1] = "NOTIFICATION_MEDIUM_EMAIL";
  return NotificationMedium;
}(NotificationMedium || {});
var PersonaType = /*#__PURE__*/function (PersonaType) {
  PersonaType[PersonaType["PERSONA_TYPE_PARTNER"] = 0] = "PERSONA_TYPE_PARTNER";
  PersonaType[PersonaType["PERSONA_TYPE_SALES_PERSON"] = 1] = "PERSONA_TYPE_SALES_PERSON";
  PersonaType[PersonaType["PERSONA_TYPE_DIGITAL_AGENT"] = 2] = "PERSONA_TYPE_DIGITAL_AGENT";
  PersonaType[PersonaType["PERSONA_TYPE_SMB"] = 3] = "PERSONA_TYPE_SMB";
  return PersonaType;
}(PersonaType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var NotificationStatus = /*#__PURE__*/function (NotificationStatus) {
  NotificationStatus[NotificationStatus["NOTIFICATION_STATUS_ENABLED"] = 0] = "NOTIFICATION_STATUS_ENABLED";
  NotificationStatus[NotificationStatus["NOTIFICATION_STATUS_DISABLED"] = 1] = "NOTIFICATION_STATUS_DISABLED";
  return NotificationStatus;
}(NotificationStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Status = /*#__PURE__*/function (Status) {
  Status[Status["STATUS_UNSET"] = 0] = "STATUS_UNSET";
  Status[Status["STATUS_DEFAULT"] = 1] = "STATUS_DEFAULT";
  Status[Status["STATUS_ENABLED"] = 2] = "STATUS_ENABLED";
  Status[Status["STATUS_DISABLED"] = 3] = "STATUS_DISABLED";
  return Status;
}(Status || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessRequirement {
  static fromProto(proto) {
    let m = new AccessRequirement();
    m = Object.assign(m, proto);
    if (proto.resource) {
      m.resource = Resource.fromProto(proto.resource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resource !== 'undefined' && this.resource !== null) {
      toReturn['resource'] = 'toApiJson' in this.resource ? this.resource.toApiJson() : this.resource;
    }
    if (typeof this.scopeIds !== 'undefined') {
      toReturn['scopeIds'] = this.scopeIds;
    }
    return toReturn;
  }
}
class MediumConfigurationBundleConfiguration {
  static fromProto(proto) {
    let m = new MediumConfigurationBundleConfiguration();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.window !== 'undefined') {
      toReturn['window'] = this.window;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    return toReturn;
  }
}
class NotificationTypeEmail {
  static fromProto(proto) {
    let m = new NotificationTypeEmail();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    if (proto.subjectTemplate) {
      m.subjectTemplate = Template.fromProto(proto.subjectTemplate);
    }
    if (proto.from) {
      m.from = NotificationTypeEmailParticipantTemplate.fromProto(proto.from);
    }
    if (proto.contentType) {
      m.contentType = enumStringToValue$4(ContentType, proto.contentType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.subjectTemplate !== 'undefined' && this.subjectTemplate !== null) {
      toReturn['subjectTemplate'] = 'toApiJson' in this.subjectTemplate ? this.subjectTemplate.toApiJson() : this.subjectTemplate;
    }
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class MediumConfigurationEmailConfiguration {
  static fromProto(proto) {
    let m = new MediumConfigurationEmailConfiguration();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    if (proto.subjectTemplate) {
      m.subjectTemplate = Template.fromProto(proto.subjectTemplate);
    }
    if (proto.from) {
      m.from = MediumConfigurationEmailConfigurationParticipantTemplate.fromProto(proto.from);
    }
    if (proto.contentType) {
      m.contentType = enumStringToValue$4(ContentType, proto.contentType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.subjectTemplate !== 'undefined' && this.subjectTemplate !== null) {
      toReturn['subjectTemplate'] = 'toApiJson' in this.subjectTemplate ? this.subjectTemplate.toApiJson() : this.subjectTemplate;
    }
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class Hydrator {
  static fromProto(proto) {
    let m = new Hydrator();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined') {
      toReturn['accountGroup'] = this.accountGroup;
    }
    if (typeof this.salesperson !== 'undefined') {
      toReturn['salesperson'] = this.salesperson;
    }
    if (typeof this.product !== 'undefined') {
      toReturn['product'] = this.product;
    }
    if (typeof this.partnerBranding !== 'undefined') {
      toReturn['partnerBranding'] = this.partnerBranding;
    }
    if (typeof this.digitalAgent !== 'undefined') {
      toReturn['digitalAgent'] = this.digitalAgent;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    return toReturn;
  }
}
class TemplateInlineTemplate {
  static fromProto(proto) {
    let m = new TemplateInlineTemplate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class MediumConfiguration {
  static fromProto(proto) {
    let m = new MediumConfiguration();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$4(NotificationMedium, proto.medium);
    }
    if (proto.bundleConfiguration) {
      m.bundleConfiguration = MediumConfigurationBundleConfiguration.fromProto(proto.bundleConfiguration);
    }
    if (proto.emailConfiguration) {
      m.emailConfiguration = MediumConfigurationEmailConfiguration.fromProto(proto.emailConfiguration);
    }
    if (proto.webConfiguration) {
      m.webConfiguration = MediumConfigurationWebConfiguration.fromProto(proto.webConfiguration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.linkTemplateId !== 'undefined') {
      toReturn['linkTemplateId'] = this.linkTemplateId;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    if (typeof this.bundleConfiguration !== 'undefined' && this.bundleConfiguration !== null) {
      toReturn['bundleConfiguration'] = 'toApiJson' in this.bundleConfiguration ? this.bundleConfiguration.toApiJson() : this.bundleConfiguration;
    }
    if (typeof this.emailConfiguration !== 'undefined' && this.emailConfiguration !== null) {
      toReturn['emailConfiguration'] = 'toApiJson' in this.emailConfiguration ? this.emailConfiguration.toApiJson() : this.emailConfiguration;
    }
    if (typeof this.webConfiguration !== 'undefined' && this.webConfiguration !== null) {
      toReturn['webConfiguration'] = 'toApiJson' in this.webConfiguration ? this.webConfiguration.toApiJson() : this.webConfiguration;
    }
    return toReturn;
  }
}
class NotificationType {
  static fromProto(proto) {
    let m = new NotificationType();
    m = Object.assign(m, proto);
    if (proto.configurations) {
      m.configurations = proto.configurations.map(MediumConfiguration.fromProto);
    }
    if (proto.hydrators) {
      m.hydrators = proto.hydrators.map(Hydrator.fromProto);
    }
    if (proto.accessRequirements) {
      m.accessRequirements = proto.accessRequirements.map(AccessRequirement.fromProto);
    }
    if (proto.web) {
      m.web = NotificationTypeWeb.fromProto(proto.web);
    }
    if (proto.webBundle) {
      m.webBundle = NotificationTypeWebBundle.fromProto(proto.webBundle);
    }
    if (proto.email) {
      m.email = NotificationTypeEmail.fromProto(proto.email);
    }
    if (proto.personaAccessRequirements) {
      m.personaAccessRequirements = proto.personaAccessRequirements.map(v => enumStringToValue$4(PersonaType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.configurations !== 'undefined' && this.configurations !== null) {
      toReturn['configurations'] = 'toApiJson' in this.configurations ? this.configurations.toApiJson() : this.configurations;
    }
    if (typeof this.domainId !== 'undefined') {
      toReturn['domainId'] = this.domainId;
    }
    if (typeof this.hydrators !== 'undefined' && this.hydrators !== null) {
      toReturn['hydrators'] = 'toApiJson' in this.hydrators ? this.hydrators.toApiJson() : this.hydrators;
    }
    if (typeof this.accessRequirements !== 'undefined' && this.accessRequirements !== null) {
      toReturn['accessRequirements'] = 'toApiJson' in this.accessRequirements ? this.accessRequirements.toApiJson() : this.accessRequirements;
    }
    if (typeof this.web !== 'undefined' && this.web !== null) {
      toReturn['web'] = 'toApiJson' in this.web ? this.web.toApiJson() : this.web;
    }
    if (typeof this.webBundle !== 'undefined' && this.webBundle !== null) {
      toReturn['webBundle'] = 'toApiJson' in this.webBundle ? this.webBundle.toApiJson() : this.webBundle;
    }
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.personaAccessRequirements !== 'undefined') {
      toReturn['personaAccessRequirements'] = this.personaAccessRequirements;
    }
    if (typeof this.featureFlagId !== 'undefined') {
      toReturn['featureFlagId'] = this.featureFlagId;
    }
    if (typeof this.locales !== 'undefined') {
      toReturn['locales'] = this.locales;
    }
    return toReturn;
  }
}
class MediumConfigurationEmailConfigurationParticipantTemplate {
  static fromProto(proto) {
    let m = new MediumConfigurationEmailConfigurationParticipantTemplate();
    m = Object.assign(m, proto);
    if (proto.nameTemplate) {
      m.nameTemplate = Template.fromProto(proto.nameTemplate);
    }
    if (proto.addressTemplate) {
      m.addressTemplate = Template.fromProto(proto.addressTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nameTemplate !== 'undefined' && this.nameTemplate !== null) {
      toReturn['nameTemplate'] = 'toApiJson' in this.nameTemplate ? this.nameTemplate.toApiJson() : this.nameTemplate;
    }
    if (typeof this.addressTemplate !== 'undefined' && this.addressTemplate !== null) {
      toReturn['addressTemplate'] = 'toApiJson' in this.addressTemplate ? this.addressTemplate.toApiJson() : this.addressTemplate;
    }
    return toReturn;
  }
}
class NotificationTypeEmailParticipantTemplate {
  static fromProto(proto) {
    let m = new NotificationTypeEmailParticipantTemplate();
    m = Object.assign(m, proto);
    if (proto.nameTemplate) {
      m.nameTemplate = Template.fromProto(proto.nameTemplate);
    }
    if (proto.addressTemplate) {
      m.addressTemplate = Template.fromProto(proto.addressTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nameTemplate !== 'undefined' && this.nameTemplate !== null) {
      toReturn['nameTemplate'] = 'toApiJson' in this.nameTemplate ? this.nameTemplate.toApiJson() : this.nameTemplate;
    }
    if (typeof this.addressTemplate !== 'undefined' && this.addressTemplate !== null) {
      toReturn['addressTemplate'] = 'toApiJson' in this.addressTemplate ? this.addressTemplate.toApiJson() : this.addressTemplate;
    }
    return toReturn;
  }
}
class Resource {
  static fromProto(proto) {
    let m = new Resource();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class Template {
  static fromProto(proto) {
    let m = new Template();
    m = Object.assign(m, proto);
    if (proto.inline) {
      m.inline = TemplateInlineTemplate.fromProto(proto.inline);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.inline !== 'undefined' && this.inline !== null) {
      toReturn['inline'] = 'toApiJson' in this.inline ? this.inline.toApiJson() : this.inline;
    }
    return toReturn;
  }
}
class NotificationTypeWeb {
  static fromProto(proto) {
    let m = new NotificationTypeWeb();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class NotificationTypeWebBundle {
  static fromProto(proto) {
    let m = new NotificationTypeWebBundle();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.window !== 'undefined') {
      toReturn['window'] = this.window;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class MediumConfigurationWebConfiguration {
  static fromProto(proto) {
    let m = new MediumConfigurationWebConfiguration();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NotificationContextAccountGroup {
  static fromProto(proto) {
    let m = new NotificationContextAccountGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ListNotificationsRequestFilter {
  static fromProto(proto) {
    let m = new ListNotificationsRequestFilter();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$3(NotificationMedium, proto.medium);
    }
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class GetNotificationSettingsRequest {
  static fromProto(proto) {
    let m = new GetNotificationSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetNotificationSettingsResponse {
  static fromProto(proto) {
    let m = new GetNotificationSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.notificationSettings) {
      m.notificationSettings = proto.notificationSettings.map(NotificationSetting$1.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationSettings !== 'undefined' && this.notificationSettings !== null) {
      toReturn['notificationSettings'] = 'toApiJson' in this.notificationSettings ? this.notificationSettings.toApiJson() : this.notificationSettings;
    }
    return toReturn;
  }
}
class GetNotificationTypeSettingsRequest {
  static fromProto(proto) {
    let m = new GetNotificationTypeSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = NotificationTypeSettingContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class GetNotificationTypeSettingsResponse {
  static fromProto(proto) {
    let m = new GetNotificationTypeSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = proto.settings.map(NotificationTypeSetting.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    return toReturn;
  }
}
class GetOverviewRequest {
  static fromProto(proto) {
    let m = new GetOverviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetOverviewResponse {
  static fromProto(proto) {
    let m = new GetOverviewResponse();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = NotificationType.fromProto(proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.type !== 'undefined' && this.type !== null) {
      toReturn['type'] = 'toApiJson' in this.type ? this.type.toApiJson() : this.type;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListNotificationTypesRequest {
  static fromProto(proto) {
    let m = new ListNotificationTypesRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListNotificationTypesResponse {
  static fromProto(proto) {
    let m = new ListNotificationTypesResponse();
    m = Object.assign(m, proto);
    if (proto.types) {
      m.types = proto.types.map(NotificationType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.types !== 'undefined' && this.types !== null) {
      toReturn['types'] = 'toApiJson' in this.types ? this.types.toApiJson() : this.types;
    }
    return toReturn;
  }
}
class ListNotificationsRequest {
  static fromProto(proto) {
    let m = new ListNotificationsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filter) {
      m.filter = ListNotificationsRequestFilter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.flatten !== 'undefined') {
      toReturn['flatten'] = this.flatten;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListNotificationsResponse {
  static fromProto(proto) {
    let m = new ListNotificationsResponse();
    m = Object.assign(m, proto);
    if (proto.notifications) {
      m.notifications = proto.notifications.map(Notification.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notifications !== 'undefined' && this.notifications !== null) {
      toReturn['notifications'] = 'toApiJson' in this.notifications ? this.notifications.toApiJson() : this.notifications;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class Notification {
  static fromProto(proto) {
    let m = new Notification();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.web) {
      m.web = NotificationWebNotification.fromProto(proto.web);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.followed !== 'undefined') {
      toReturn['followed'] = this.followed;
    }
    if (typeof this.viewed !== 'undefined') {
      toReturn['viewed'] = this.viewed;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.web !== 'undefined' && this.web !== null) {
      toReturn['web'] = 'toApiJson' in this.web ? this.web.toApiJson() : this.web;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class NotificationContext {
  static fromProto(proto) {
    let m = new NotificationContext();
    m = Object.assign(m, proto);
    if (proto.partner) {
      m.partner = NotificationContextPartner.fromProto(proto.partner);
    }
    if (proto.accountGroup) {
      m.accountGroup = NotificationContextAccountGroup.fromProto(proto.accountGroup);
    }
    if (proto.user) {
      m.user = NotificationContextUser.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    return toReturn;
  }
}
let NotificationSetting$1 = class NotificationSetting {
  static fromProto(proto) {
    let m = new NotificationSetting();
    m = Object.assign(m, proto);
    if (proto.notificationMedium) {
      m.notificationMedium = enumStringToValue$3(NotificationMedium, proto.notificationMedium);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(NotificationStatus, proto.status);
    }
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.notificationMedium !== 'undefined') {
      toReturn['notificationMedium'] = this.notificationMedium;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
};
class NotificationTypeSetting {
  static fromProto(proto) {
    let m = new NotificationTypeSetting();
    m = Object.assign(m, proto);
    if (proto.configurations) {
      m.configurations = proto.configurations.map(NotificationTypeSettingNotificationTypeSettingMediumConfiguration.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.configurations !== 'undefined' && this.configurations !== null) {
      toReturn['configurations'] = 'toApiJson' in this.configurations ? this.configurations.toApiJson() : this.configurations;
    }
    return toReturn;
  }
}
class NotificationTypeSettingContext {
  static fromProto(proto) {
    let m = new NotificationTypeSettingContext();
    m = Object.assign(m, proto);
    if (proto.partner) {
      m.partner = NotificationTypeSettingContextNotificationTypeSettingContextPartner.fromProto(proto.partner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    return toReturn;
  }
}
class NotificationTypeSettingContextNotificationTypeSettingContextPartner {
  static fromProto(proto) {
    let m = new NotificationTypeSettingContextNotificationTypeSettingContextPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class NotificationTypeSettingNotificationTypeSettingMediumConfiguration {
  static fromProto(proto) {
    let m = new NotificationTypeSettingNotificationTypeSettingMediumConfiguration();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$3(NotificationMedium, proto.medium);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class UpdateNotificationsRequestOperation {
  static fromProto(proto) {
    let m = new UpdateNotificationsRequestOperation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.followed !== 'undefined') {
      toReturn['followed'] = this.followed;
    }
    if (typeof this.viewed !== 'undefined') {
      toReturn['viewed'] = this.viewed;
    }
    return toReturn;
  }
}
class NotificationContextPartner {
  static fromProto(proto) {
    let m = new NotificationContextPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class RegisterAppTokenRequest {
  static fromProto(proto) {
    let m = new RegisterAppTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.registrationToken !== 'undefined') {
      toReturn['registrationToken'] = this.registrationToken;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.deviceId !== 'undefined') {
      toReturn['deviceId'] = this.deviceId;
    }
    return toReturn;
  }
}
class RegisterAppTokenResponse {
  static fromProto(proto) {
    let m = new RegisterAppTokenResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SubscribeRequest {
  static fromProto(proto) {
    let m = new SubscribeRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    if (proto.notificationMedium) {
      m.notificationMedium = proto.notificationMedium.map(v => enumStringToValue$3(NotificationMedium, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.notificationMedium !== 'undefined') {
      toReturn['notificationMedium'] = this.notificationMedium;
    }
    return toReturn;
  }
}
class UnsubscribeRequest {
  static fromProto(proto) {
    let m = new UnsubscribeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class UpdateNotificationSettingsRequestUpdateNotificationSettingsOperation {
  static fromProto(proto) {
    let m = new UpdateNotificationSettingsRequestUpdateNotificationSettingsOperation();
    m = Object.assign(m, proto);
    if (proto.notificationMedium) {
      m.notificationMedium = enumStringToValue$3(NotificationMedium, proto.notificationMedium);
    }
    if (proto.context) {
      m.context = NotificationContext.fromProto(proto.context);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(NotificationStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.notificationMedium !== 'undefined') {
      toReturn['notificationMedium'] = this.notificationMedium;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.propagate !== 'undefined') {
      toReturn['propagate'] = this.propagate;
    }
    return toReturn;
  }
}
class UpdateNotificationSettingsRequest {
  static fromProto(proto) {
    let m = new UpdateNotificationSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.notificationSettings) {
      m.notificationSettings = proto.notificationSettings.map(UpdateNotificationSettingsRequestUpdateNotificationSettingsOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationSettings !== 'undefined' && this.notificationSettings !== null) {
      toReturn['notificationSettings'] = 'toApiJson' in this.notificationSettings ? this.notificationSettings.toApiJson() : this.notificationSettings;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class UpdateNotificationTypeSettingsRequestUpdateNotificationTypeSettingOperation {
  static fromProto(proto) {
    let m = new UpdateNotificationTypeSettingsRequestUpdateNotificationTypeSettingOperation();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = NotificationTypeSettingContext.fromProto(proto.context);
    }
    if (proto.medium) {
      m.medium = enumStringToValue$3(NotificationMedium, proto.medium);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class UpdateNotificationTypeSettingsRequest {
  static fromProto(proto) {
    let m = new UpdateNotificationTypeSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateNotificationTypeSettingsRequestUpdateNotificationTypeSettingOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}
class UpdateNotificationsRequest {
  static fromProto(proto) {
    let m = new UpdateNotificationsRequest();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateNotificationsRequestOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class NotificationContextUser {
  static fromProto(proto) {
    let m = new NotificationContextUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamSubjectId !== 'undefined') {
      toReturn['iamSubjectId'] = this.iamSubjectId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class NotificationWebNotification {
  static fromProto(proto) {
    let m = new NotificationWebNotification();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    return toReturn;
  }
}

// WARNING mannual override is required.
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateTypeRequest {
  static fromProto(proto) {
    let m = new CreateTypeRequest();
    m = Object.assign(m, proto);
    if (proto.configurations) {
      m.configurations = proto.configurations.map(MediumConfiguration.fromProto);
    }
    if (proto.hydrators) {
      m.hydrators = proto.hydrators.map(Hydrator.fromProto);
    }
    if (proto.accessRequirements) {
      m.accessRequirements = proto.accessRequirements.map(AccessRequirement.fromProto);
    }
    if (proto.web) {
      m.web = NotificationTypeWeb.fromProto(proto.web);
    }
    if (proto.webBundle) {
      m.webBundle = NotificationTypeWebBundle.fromProto(proto.webBundle);
    }
    if (proto.email) {
      m.email = NotificationTypeEmail.fromProto(proto.email);
    }
    if (proto.personaAccessRequirements) {
      m.personaAccessRequirements = proto.personaAccessRequirements.map(v => enumStringToValue$2(PersonaType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.configurations !== 'undefined' && this.configurations !== null) {
      toReturn['configurations'] = 'toApiJson' in this.configurations ? this.configurations.toApiJson() : this.configurations;
    }
    if (typeof this.domainId !== 'undefined') {
      toReturn['domainId'] = this.domainId;
    }
    if (typeof this.hydrators !== 'undefined' && this.hydrators !== null) {
      toReturn['hydrators'] = 'toApiJson' in this.hydrators ? this.hydrators.toApiJson() : this.hydrators;
    }
    if (typeof this.accessRequirements !== 'undefined' && this.accessRequirements !== null) {
      toReturn['accessRequirements'] = 'toApiJson' in this.accessRequirements ? this.accessRequirements.toApiJson() : this.accessRequirements;
    }
    if (typeof this.web !== 'undefined' && this.web !== null) {
      toReturn['web'] = 'toApiJson' in this.web ? this.web.toApiJson() : this.web;
    }
    if (typeof this.webBundle !== 'undefined' && this.webBundle !== null) {
      toReturn['webBundle'] = 'toApiJson' in this.webBundle ? this.webBundle.toApiJson() : this.webBundle;
    }
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.personaAccessRequirements !== 'undefined') {
      toReturn['personaAccessRequirements'] = this.personaAccessRequirements;
    }
    if (typeof this.featureFlagId !== 'undefined') {
      toReturn['featureFlagId'] = this.featureFlagId;
    }
    if (typeof this.locales !== 'undefined') {
      toReturn['locales'] = this.locales;
    }
    return toReturn;
  }
}
class DeleteTypeRequest {
  static fromProto(proto) {
    let m = new DeleteTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationEmail {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationEmail();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    if (proto.subjectTemplate) {
      m.subjectTemplate = Template.fromProto(proto.subjectTemplate);
    }
    if (proto.from) {
      m.from = UpdateTypeRequestUpdateNotificationTypeOperationEmailParticipantTemplateOperation.fromProto(proto.from);
    }
    if (proto.contentType) {
      m.contentType = enumStringToValue$2(ContentType, proto.contentType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.subjectTemplate !== 'undefined' && this.subjectTemplate !== null) {
      toReturn['subjectTemplate'] = 'toApiJson' in this.subjectTemplate ? this.subjectTemplate.toApiJson() : this.subjectTemplate;
    }
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class PreviewRequestEvent {
  static fromProto(proto) {
    let m = new PreviewRequestEvent();
    m = Object.assign(m, proto);
    if (proto.emittedAt) {
      m.emittedAt = new Date(proto.emittedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.emittedAt !== 'undefined' && this.emittedAt !== null) {
      toReturn['emittedAt'] = 'toApiJson' in this.emittedAt ? this.emittedAt.toApiJson() : this.emittedAt;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
class GetTypeRequest {
  static fromProto(proto) {
    let m = new GetTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    return toReturn;
  }
}
class GetTypeResponse {
  static fromProto(proto) {
    let m = new GetTypeResponse();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = NotificationType.fromProto(proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined' && this.type !== null) {
      toReturn['type'] = 'toApiJson' in this.type ? this.type.toApiJson() : this.type;
    }
    return toReturn;
  }
}
class ListTypesRequest {
  static fromProto(proto) {
    let m = new ListTypesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListTypesResponse {
  static fromProto(proto) {
    let m = new ListTypesResponse();
    m = Object.assign(m, proto);
    if (proto.types) {
      m.types = proto.types.map(NotificationType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.types !== 'undefined' && this.types !== null) {
      toReturn['types'] = 'toApiJson' in this.types ? this.types.toApiJson() : this.types;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationMediumConfigurationOperation {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationMediumConfigurationOperation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationEmailParticipantTemplateOperation {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationEmailParticipantTemplateOperation();
    m = Object.assign(m, proto);
    if (proto.nameTemplate) {
      m.nameTemplate = Template.fromProto(proto.nameTemplate);
    }
    if (proto.addressTemplate) {
      m.addressTemplate = Template.fromProto(proto.addressTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nameTemplate !== 'undefined' && this.nameTemplate !== null) {
      toReturn['nameTemplate'] = 'toApiJson' in this.nameTemplate ? this.nameTemplate.toApiJson() : this.nameTemplate;
    }
    if (typeof this.addressTemplate !== 'undefined' && this.addressTemplate !== null) {
      toReturn['addressTemplate'] = 'toApiJson' in this.addressTemplate ? this.addressTemplate.toApiJson() : this.addressTemplate;
    }
    return toReturn;
  }
}
class PreviewRequest {
  static fromProto(proto) {
    let m = new PreviewRequest();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$2(NotificationMedium, proto.medium);
    }
    if (proto.event) {
      m.event = PreviewRequestEvent.fromProto(proto.event);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    return toReturn;
  }
}
class ReleaseRequest {
  static fromProto(proto) {
    let m = new ReleaseRequest();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$2(NotificationMedium, proto.medium);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationReplaceMediumConfiguration {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationReplaceMediumConfiguration();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = MediumConfiguration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationSetAccessRequirements {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationSetAccessRequirements();
    m = Object.assign(m, proto);
    if (proto.accessRequirements) {
      m.accessRequirements = proto.accessRequirements.map(AccessRequirement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessRequirements !== 'undefined' && this.accessRequirements !== null) {
      toReturn['accessRequirements'] = 'toApiJson' in this.accessRequirements ? this.accessRequirements.toApiJson() : this.accessRequirements;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationSetCategory {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationSetCategory();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationSetHydrators {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationSetHydrators();
    m = Object.assign(m, proto);
    if (proto.hydrators) {
      m.hydrators = proto.hydrators.map(Hydrator.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hydrators !== 'undefined' && this.hydrators !== null) {
      toReturn['hydrators'] = 'toApiJson' in this.hydrators ? this.hydrators.toApiJson() : this.hydrators;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationSetLocales {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationSetLocales();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locales !== 'undefined') {
      toReturn['locales'] = this.locales;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationSetPersonaAccessRequirements {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationSetPersonaAccessRequirements();
    m = Object.assign(m, proto);
    if (proto.personaAccessRequirements) {
      m.personaAccessRequirements = proto.personaAccessRequirements.map(v => enumStringToValue$2(PersonaType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.personaAccessRequirements !== 'undefined') {
      toReturn['personaAccessRequirements'] = this.personaAccessRequirements;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperation {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperation();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = UpdateTypeRequestUpdateNotificationTypeOperationSetCategory.fromProto(proto.category);
    }
    if (proto.replaceMediumConfiguration) {
      m.replaceMediumConfiguration = UpdateTypeRequestUpdateNotificationTypeOperationReplaceMediumConfiguration.fromProto(proto.replaceMediumConfiguration);
    }
    if (proto.mediumConfiguration) {
      m.mediumConfiguration = UpdateTypeRequestUpdateNotificationTypeOperationMediumConfigurationOperation.fromProto(proto.mediumConfiguration);
    }
    if (proto.hydrators) {
      m.hydrators = UpdateTypeRequestUpdateNotificationTypeOperationSetHydrators.fromProto(proto.hydrators);
    }
    if (proto.accessRequirements) {
      m.accessRequirements = UpdateTypeRequestUpdateNotificationTypeOperationSetAccessRequirements.fromProto(proto.accessRequirements);
    }
    if (proto.web) {
      m.web = UpdateTypeRequestUpdateNotificationTypeOperationWeb.fromProto(proto.web);
    }
    if (proto.webBundle) {
      m.webBundle = UpdateTypeRequestUpdateNotificationTypeOperationWebBundle.fromProto(proto.webBundle);
    }
    if (proto.email) {
      m.email = UpdateTypeRequestUpdateNotificationTypeOperationEmail.fromProto(proto.email);
    }
    if (proto.personaAccessRequirements) {
      m.personaAccessRequirements = UpdateTypeRequestUpdateNotificationTypeOperationSetPersonaAccessRequirements.fromProto(proto.personaAccessRequirements);
    }
    if (proto.locales) {
      m.locales = UpdateTypeRequestUpdateNotificationTypeOperationSetLocales.fromProto(proto.locales);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.replaceMediumConfiguration !== 'undefined' && this.replaceMediumConfiguration !== null) {
      toReturn['replaceMediumConfiguration'] = 'toApiJson' in this.replaceMediumConfiguration ? this.replaceMediumConfiguration.toApiJson() : this.replaceMediumConfiguration;
    }
    if (typeof this.mediumConfiguration !== 'undefined' && this.mediumConfiguration !== null) {
      toReturn['mediumConfiguration'] = 'toApiJson' in this.mediumConfiguration ? this.mediumConfiguration.toApiJson() : this.mediumConfiguration;
    }
    if (typeof this.domainId !== 'undefined') {
      toReturn['domainId'] = this.domainId;
    }
    if (typeof this.hydrators !== 'undefined' && this.hydrators !== null) {
      toReturn['hydrators'] = 'toApiJson' in this.hydrators ? this.hydrators.toApiJson() : this.hydrators;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.accessRequirements !== 'undefined' && this.accessRequirements !== null) {
      toReturn['accessRequirements'] = 'toApiJson' in this.accessRequirements ? this.accessRequirements.toApiJson() : this.accessRequirements;
    }
    if (typeof this.web !== 'undefined' && this.web !== null) {
      toReturn['web'] = 'toApiJson' in this.web ? this.web.toApiJson() : this.web;
    }
    if (typeof this.webBundle !== 'undefined' && this.webBundle !== null) {
      toReturn['webBundle'] = 'toApiJson' in this.webBundle ? this.webBundle.toApiJson() : this.webBundle;
    }
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.personaAccessRequirements !== 'undefined' && this.personaAccessRequirements !== null) {
      toReturn['personaAccessRequirements'] = 'toApiJson' in this.personaAccessRequirements ? this.personaAccessRequirements.toApiJson() : this.personaAccessRequirements;
    }
    if (typeof this.featureFlagId !== 'undefined') {
      toReturn['featureFlagId'] = this.featureFlagId;
    }
    if (typeof this.locales !== 'undefined' && this.locales !== null) {
      toReturn['locales'] = 'toApiJson' in this.locales ? this.locales.toApiJson() : this.locales;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    return toReturn;
  }
}
class UpdateTypeRequest {
  static fromProto(proto) {
    let m = new UpdateTypeRequest();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateTypeRequestUpdateNotificationTypeOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationWeb {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationWeb();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
class UpdateTypeRequestUpdateNotificationTypeOperationWebBundle {
  static fromProto(proto) {
    let m = new UpdateTypeRequestUpdateNotificationTypeOperationWebBundle();
    m = Object.assign(m, proto);
    if (proto.contentTemplate) {
      m.contentTemplate = Template.fromProto(proto.contentTemplate);
    }
    if (proto.linkTemplate) {
      m.linkTemplate = Template.fromProto(proto.linkTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.window !== 'undefined') {
      toReturn['window'] = this.window;
    }
    if (typeof this.contentTemplate !== 'undefined' && this.contentTemplate !== null) {
      toReturn['contentTemplate'] = 'toApiJson' in this.contentTemplate ? this.contentTemplate.toApiJson() : this.contentTemplate;
    }
    if (typeof this.linkTemplate !== 'undefined' && this.linkTemplate !== null) {
      toReturn['linkTemplate'] = 'toApiJson' in this.linkTemplate ? this.linkTemplate.toApiJson() : this.linkTemplate;
    }
    if (typeof this.sampleData !== 'undefined') {
      toReturn['sampleData'] = this.sampleData;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SaveNotificationRequest {
  static fromProto(proto) {
    let m = new SaveNotificationRequest();
    m = Object.assign(m, proto);
    if (proto.medium) {
      m.medium = enumStringToValue$1(NotificationMedium, proto.medium);
    }
    if (proto.notificationTime) {
      m.notificationTime = new Date(proto.notificationTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationTypeId !== 'undefined') {
      toReturn['notificationTypeId'] = this.notificationTypeId;
    }
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.notificationTime !== 'undefined' && this.notificationTime !== null) {
      toReturn['notificationTime'] = 'toApiJson' in this.notificationTime ? this.notificationTime.toApiJson() : this.notificationTime;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkUpdateRequest {
  static fromProto(proto) {
    let m = new BulkUpdateRequest();
    m = Object.assign(m, proto);
    if (proto.changes) {
      m.changes = Preference.fromProto(proto.changes);
    }
    if (proto.preferenceByIdentifiers) {
      m.preferenceByIdentifiers = BulkUpdateRequestByIdentifier.fromProto(proto.preferenceByIdentifiers);
    }
    if (proto.businessByUser) {
      m.businessByUser = BulkUpdateRequestByUser.fromProto(proto.businessByUser);
    }
    if (proto.businessByPartner) {
      m.businessByPartner = BulkUpdateRequestByPartner.fromProto(proto.businessByPartner);
    }
    if (proto.userByPartner) {
      m.userByPartner = BulkUpdateRequestByPartner.fromProto(proto.userByPartner);
    }
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(Identifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.changes !== 'undefined' && this.changes !== null) {
      toReturn['changes'] = 'toApiJson' in this.changes ? this.changes.toApiJson() : this.changes;
    }
    if (typeof this.preferenceByIdentifiers !== 'undefined' && this.preferenceByIdentifiers !== null) {
      toReturn['preferenceByIdentifiers'] = 'toApiJson' in this.preferenceByIdentifiers ? this.preferenceByIdentifiers.toApiJson() : this.preferenceByIdentifiers;
    }
    if (typeof this.businessByUser !== 'undefined' && this.businessByUser !== null) {
      toReturn['businessByUser'] = 'toApiJson' in this.businessByUser ? this.businessByUser.toApiJson() : this.businessByUser;
    }
    if (typeof this.businessByPartner !== 'undefined' && this.businessByPartner !== null) {
      toReturn['businessByPartner'] = 'toApiJson' in this.businessByPartner ? this.businessByPartner.toApiJson() : this.businessByPartner;
    }
    if (typeof this.userByPartner !== 'undefined' && this.userByPartner !== null) {
      toReturn['userByPartner'] = 'toApiJson' in this.userByPartner ? this.userByPartner.toApiJson() : this.userByPartner;
    }
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    if (typeof this.partialIdentifiers !== 'undefined') {
      toReturn['partialIdentifiers'] = this.partialIdentifiers;
    }
    return toReturn;
  }
}
class BulkUpdateResponse {
  static fromProto(proto) {
    let m = new BulkUpdateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.progressToken !== 'undefined') {
      toReturn['progressToken'] = this.progressToken;
    }
    return toReturn;
  }
}
class BulkUpdateRequestByIdentifier {
  static fromProto(proto) {
    let m = new BulkUpdateRequestByIdentifier();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(Identifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class BulkUpdateRequestByPartner {
  static fromProto(proto) {
    let m = new BulkUpdateRequestByPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class BulkUpdateRequestByUser {
  static fromProto(proto) {
    let m = new BulkUpdateRequestByUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    return toReturn;
  }
}
class DeleteRequest {
  static fromProto(proto) {
    let m = new DeleteRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class DeleteResponse {
  static fromProto(proto) {
    let m = new DeleteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetAvailableSectionsRequest {
  static fromProto(proto) {
    let m = new GetAvailableSectionsRequest();
    m = Object.assign(m, proto);
    if (proto.partialIdentifier) {
      m.partialIdentifier = Identifier.fromProto(proto.partialIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partialIdentifier !== 'undefined' && this.partialIdentifier !== null) {
      toReturn['partialIdentifier'] = 'toApiJson' in this.partialIdentifier ? this.partialIdentifier.toApiJson() : this.partialIdentifier;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetAvailableSectionsResponse {
  static fromProto(proto) {
    let m = new GetAvailableSectionsResponse();
    m = Object.assign(m, proto);
    if (proto.sections) {
      m.sections = proto.sections.map(SectionSettings.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sections !== 'undefined' && this.sections !== null) {
      toReturn['sections'] = 'toApiJson' in this.sections ? this.sections.toApiJson() : this.sections;
    }
    return toReturn;
  }
}
class GetRequest {
  static fromProto(proto) {
    let m = new GetRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetResponse {
  static fromProto(proto) {
    let m = new GetResponse();
    m = Object.assign(m, proto);
    if (proto.computed) {
      m.computed = Preference.fromProto(proto.computed);
    }
    if (proto.components) {
      m.components = proto.components.map(Preference.fromProto);
    }
    if (proto.defaults) {
      m.defaults = Preference.fromProto(proto.defaults);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.computed !== 'undefined' && this.computed !== null) {
      toReturn['computed'] = 'toApiJson' in this.computed ? this.computed.toApiJson() : this.computed;
    }
    if (typeof this.components !== 'undefined' && this.components !== null) {
      toReturn['components'] = 'toApiJson' in this.components ? this.components.toApiJson() : this.components;
    }
    if (typeof this.defaults !== 'undefined' && this.defaults !== null) {
      toReturn['defaults'] = 'toApiJson' in this.defaults ? this.defaults.toApiJson() : this.defaults;
    }
    if (typeof this.userNotificationsDisabled !== 'undefined') {
      toReturn['userNotificationsDisabled'] = this.userNotificationsDisabled;
    }
    return toReturn;
  }
}
class Identifier {
  static fromProto(proto) {
    let m = new Identifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListRequest {
  static fromProto(proto) {
    let m = new ListRequest();
    m = Object.assign(m, proto);
    if (proto.partialIdentifier) {
      m.partialIdentifier = Identifier.fromProto(proto.partialIdentifier);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partialIdentifier !== 'undefined' && this.partialIdentifier !== null) {
      toReturn['partialIdentifier'] = 'toApiJson' in this.partialIdentifier ? this.partialIdentifier.toApiJson() : this.partialIdentifier;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListResponse {
  static fromProto(proto) {
    let m = new ListResponse();
    m = Object.assign(m, proto);
    if (proto.computed) {
      m.computed = proto.computed.map(Preference.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.computed !== 'undefined' && this.computed !== null) {
      toReturn['computed'] = 'toApiJson' in this.computed ? this.computed.toApiJson() : this.computed;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class NotificationActivity {
  static fromProto(proto) {
    let m = new NotificationActivity();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(NotificationSetting.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.localizedTitle !== 'undefined') {
      toReturn['localizedTitle'] = this.localizedTitle;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
// WARNING mannual override is required.
class NotificationSetting {
  static fromProto(proto) {
    let m = new NotificationSetting();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(Status, proto.status);
    } // WARNING mannual override is required.
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.localizedTitle !== 'undefined') {
      toReturn['localizedTitle'] = this.localizedTitle;
    }
    return toReturn;
  }
}
class Preference {
  static fromProto(proto) {
    let m = new Preference();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    if (proto.instantSettings) {
      m.instantSettings = proto.instantSettings.map(NotificationSetting.fromProto);
    }
    if (proto.digestSettings) {
      m.digestSettings = proto.digestSettings.map(NotificationSetting.fromProto);
    }
    if (proto.executiveReportSettings) {
      m.executiveReportSettings = proto.executiveReportSettings.map(NotificationSetting.fromProto);
    }
    if (proto.instant) {
      m.instant = enumStringToValue(Status, proto.instant);
    } // WARNING mannual override is required.
    if (proto.digest) {
      m.digest = enumStringToValue(Status, proto.digest);
    } // WARNING mannual override is required.
    if (proto.monthlyTaskReport) {
      m.monthlyTaskReport = enumStringToValue(Status, proto.monthlyTaskReport);
    } // WARNING mannual override is required.
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    if (typeof this.instantSettings !== 'undefined' && this.instantSettings !== null) {
      toReturn['instantSettings'] = 'toApiJson' in this.instantSettings ? this.instantSettings.toApiJson() : this.instantSettings;
    }
    if (typeof this.digestSettings !== 'undefined' && this.digestSettings !== null) {
      toReturn['digestSettings'] = 'toApiJson' in this.digestSettings ? this.digestSettings.toApiJson() : this.digestSettings;
    }
    if (typeof this.executiveReportSettings !== 'undefined' && this.executiveReportSettings !== null) {
      toReturn['executiveReportSettings'] = 'toApiJson' in this.executiveReportSettings ? this.executiveReportSettings.toApiJson() : this.executiveReportSettings;
    }
    if (typeof this.instant !== 'undefined') {
      toReturn['instant'] = this.instant;
    }
    if (typeof this.digest !== 'undefined') {
      toReturn['digest'] = this.digest;
    }
    if (typeof this.monthlyTaskReport !== 'undefined') {
      toReturn['monthlyTaskReport'] = this.monthlyTaskReport;
    }
    return toReturn;
  }
}
class Product {
  static fromProto(proto) {
    let m = new Product();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(NotificationActivity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    return toReturn;
  }
}
class SectionSettings {
  static fromProto(proto) {
    let m = new SectionSettings();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = NotificationSetting.fromProto(proto.section);
    }
    if (proto.products) {
      m.products = proto.products.map(Product.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    return toReturn;
  }
}
class UpdateRequest {
  static fromProto(proto) {
    let m = new UpdateRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = Identifier.fromProto(proto.identifier);
    }
    if (proto.changes) {
      m.changes = Preference.fromProto(proto.changes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    if (typeof this.changes !== 'undefined' && this.changes !== null) {
      toReturn['changes'] = 'toApiJson' in this.changes ? this.changes.toApiJson() : this.changes;
    }
    return toReturn;
  }
}
class UpdateResponse {
  static fromProto(proto) {
    let m = new UpdateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}

// *********************************
// WARNING THIS FILE CONTAINS MANUAL CHANGES
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'notifications-api.vendasta-local.com',
  'test': '',
  'demo': 'notifications-api-demo.apigateway.co',
  'prod': 'notifications-api-prod.apigateway.co',
  'production': 'notifications-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let NotificationsApiService = /*#__PURE__*/(() => {
  class NotificationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listNotificationTypes(r) {
      const request = r.toApiJson ? r : new ListNotificationTypesRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/ListNotificationTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListNotificationTypesResponse.fromProto(resp)));
    }
    getNotificationTypeSettings(r) {
      const request = r.toApiJson ? r : new GetNotificationTypeSettingsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/GetNotificationTypeSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetNotificationTypeSettingsResponse.fromProto(resp)));
    }
    updateNotificationTypeSettings(r) {
      const request = r.toApiJson ? r : new UpdateNotificationTypeSettingsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/UpdateNotificationTypeSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateNotificationSettings(r) {
      const request = r.toApiJson ? r : new UpdateNotificationSettingsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/UpdateNotificationSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getNotificationSettings(r) {
      const request = r.toApiJson ? r : new GetNotificationSettingsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/GetNotificationSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetNotificationSettingsResponse.fromProto(resp)));
    }
    listNotifications(r) {
      const request = r.toApiJson ? r : new ListNotificationsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/ListNotifications", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListNotificationsResponse.fromProto(resp)));
    }
    updateNotifications(r) {
      const request = r.toApiJson ? r : new UpdateNotificationsRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/UpdateNotifications", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    subscribe(r) {
      const request = r.toApiJson ? r : new SubscribeRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/Subscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerAppToken(r) {
      const request = r.toApiJson ? r : new RegisterAppTokenRequest(r);
      return this.http.post(this._host + "/notifications.v1.Notifications/RegisterAppToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => RegisterAppTokenResponse.fromProto(resp)));
    }
  }
  NotificationsApiService.ɵfac = function NotificationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsApiService)();
  };
  NotificationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsApiService,
    factory: NotificationsApiService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsService = /*#__PURE__*/(() => {
  class NotificationsService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    list$(partnerId, pageSize, cursor, medium, flatten) {
      return this.apiService.listNotifications({
        pageSize: pageSize || 15,
        cursor: cursor,
        filter: {
          medium: medium
        },
        flatten: flatten,
        partnerId: partnerId
      });
    }
    listTypes$(partnerId) {
      return this.apiService.listNotificationTypes({
        partnerId: partnerId
      });
    }
    updateNotifications$(partnerId, operations) {
      return this.apiService.updateNotifications({
        operations: operations,
        partnerId: partnerId
      });
    }
    updateNotificationSetting$(partnerId, operations) {
      return this.apiService.updateNotificationSettings({
        notificationSettings: operations,
        partnerId: partnerId
      });
    }
    getNotificationSetting$(partnerId, context) {
      return this.apiService.getNotificationSettings({
        context: context,
        partnerId: partnerId
      }).pipe(map(resp => resp && resp.notificationSettings ? resp.notificationSettings : []), map(settings => settings.map(setting => {
        setting.notificationMedium = !setting.notificationMedium ? NotificationMedium.NOTIFICATION_MEDIUM_WEB : setting.notificationMedium;
        setting.status = !setting.status ? NotificationStatus.NOTIFICATION_STATUS_ENABLED : setting.status;
        return setting;
      })));
    }
    registerAppToken$(registrationToken, userId, partnerId, deviceId) {
      return this.apiService.registerAppToken({
        registrationToken: registrationToken,
        userId: userId,
        partnerId: partnerId,
        deviceId: deviceId
      });
    }
  }
  NotificationsService.ɵfac = function NotificationsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsService)(i0.ɵɵinject(NotificationsApiService));
  };
  NotificationsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsService,
    factory: NotificationsService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let NotificationsAdminApiService = /*#__PURE__*/(() => {
  class NotificationsAdminApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createType(r) {
      const request = r.toApiJson ? r : new CreateTypeRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/CreateType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getType(r) {
      const request = r.toApiJson ? r : new GetTypeRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/GetType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTypeResponse.fromProto(resp)));
    }
    updateType(r) {
      const request = r.toApiJson ? r : new UpdateTypeRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/UpdateType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteType(r) {
      const request = r.toApiJson ? r : new DeleteTypeRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/DeleteType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listTypes(r) {
      const request = r.toApiJson ? r : new ListTypesRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/ListTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTypesResponse.fromProto(resp)));
    }
    release(r) {
      const request = r.toApiJson ? r : new ReleaseRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/Release", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    preview(r) {
      const request = r.toApiJson ? r : new PreviewRequest(r);
      return this.http.post(this._host + "/notifications.v1.NotificationsAdmin/Preview", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  NotificationsAdminApiService.ɵfac = function NotificationsAdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsAdminApiService)();
  };
  NotificationsAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsAdminApiService,
    factory: NotificationsAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsAdminService = /*#__PURE__*/(() => {
  class NotificationsAdminService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    createType$(create) {
      return this.apiService.createType(create).pipe(map(() => {}));
    }
    getType$(typeId) {
      return this.apiService.getType({
        notificationTypeId: typeId
      }).pipe(map(resp => resp.type));
    }
    deleteType$(typeId) {
      return this.apiService.deleteType({
        notificationTypeId: typeId
      }).pipe(map(() => {}));
    }
    updateType$(typeId, operations) {
      return this.apiService.updateType({
        notificationTypeId: typeId,
        operations: operations
      }).pipe(map(() => {}));
    }
    listTypes$(pageSize, cursor) {
      return this.apiService.listTypes({
        pageSize: pageSize || 25,
        cursor: cursor
      });
    }
    releaseType$(typeId, medium, userIds) {
      return this.apiService.release({
        notificationTypeId: typeId,
        medium: medium,
        userId: userIds
      }).pipe(map(() => {}));
    }
    preview$(typeId, medium, event) {
      return this.apiService.preview({
        notificationTypeId: typeId,
        medium: medium,
        event: event
      }).pipe(map(() => {}));
    }
  }
  NotificationsAdminService.ɵfac = function NotificationsAdminService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsAdminService)(i0.ɵɵinject(NotificationsAdminApiService));
  };
  NotificationsAdminService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsAdminService,
    factory: NotificationsAdminService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsAdminService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function setName(name) {
  return {
    name: name || ''
  };
}
function setCategory(category) {
  return {
    category: {
      category: category
    }
  };
}
function setDescription(description) {
  return {
    description: description || ''
  };
}
function replaceMediumConfiguration(config) {
  return {
    replaceMediumConfiguration: config
  };
}
function setEmailEnabled(enabled) {
  return {
    email: {
      enabled: enabled
    }
  };
}
function setEmailContentTemplate(template) {
  return {
    email: {
      contentTemplate: template
    }
  };
}
function setEmailLinkTemplate(template) {
  return {
    email: {
      linkTemplate: template
    }
  };
}
function setEmailSubjectTemplate(template) {
  return {
    email: {
      subjectTemplate: template
    }
  };
}
function setEmailFromNameTemplate(template) {
  return {
    email: {
      from: {
        nameTemplate: template
      }
    }
  };
}
function setEmailFromAddressTemplate(template) {
  return {
    email: {
      from: {
        addressTemplate: template
      }
    }
  };
}
function setEmailContentType(contentType) {
  return {
    email: {
      contentType: contentType || ContentType.CONTENT_TYPE_HTML
    }
  };
}
function setEmailServiceProvider(serviceProvider) {
  return {
    email: {
      espId: serviceProvider || ''
    }
  };
}
function setEmailSample(sample) {
  return {
    email: {
      sampleData: sample ?? {}
    }
  };
}
function setWebEnabled(enabled) {
  return {
    web: {
      enabled: enabled
    }
  };
}
function setWebContentTemplate(template) {
  return {
    web: {
      contentTemplate: template
    }
  };
}
function setWebLinkTemplate(template) {
  return {
    web: {
      linkTemplate: template
    }
  };
}
function setWebSample(sample) {
  return {
    web: {
      sampleData: sample ?? {}
    }
  };
}
function setWebBundleEnabled(enabled) {
  return {
    webBundle: {
      enabled: enabled
    }
  };
}
function setWebBundleContentTemplate(template) {
  return {
    webBundle: {
      contentTemplate: template
    }
  };
}
function setWebBundleLinkTemplate(template) {
  return {
    webBundle: {
      linkTemplate: template
    }
  };
}
function setWebBundleSample(sample) {
  return {
    webBundle: {
      sampleData: sample ?? {}
    }
  };
}
function setWebBundleWindow(window) {
  return {
    webBundle: {
      window: window || '0s'
    }
  };
}
function setDomainId(domainId) {
  return {
    domainId: domainId || ''
  };
}
function setFeatureFlagId(id) {
  return {
    featureFlagId: id || ''
  };
}
function setLocales(locales) {
  return {
    locales: {
      locales: locales || []
    }
  };
}
function setHydrators(hydrators) {
  return {
    hydrators: {
      hydrators: hydrators
    }
  };
}
function setAccountGroupHydrator(enabled) {
  return {
    hydrators: {
      hydrators: [{
        accountGroup: enabled
      }]
    }
  };
}
function setSalespersonHydrator(enabled) {
  return {
    hydrators: {
      hydrators: [{
        salesperson: enabled
      }]
    }
  };
}
function setProductHydrator(enabled) {
  return {
    hydrators: {
      hydrators: [{
        product: enabled
      }]
    }
  };
}
function setPartnerBrandingHydrator(enabled) {
  return {
    hydrators: {
      hydrators: [{
        partnerBranding: enabled
      }]
    }
  };
}
function setAccessRequirement(accessRequirements) {
  return {
    accessRequirements: {
      accessRequirements: accessRequirements
    }
  };
}
function setPersonaAccessRequirements(personaTypes) {
  return {
    personaAccessRequirements: {
      personaAccessRequirements: personaTypes
    }
  };
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let UnsubscribeApiService = /*#__PURE__*/(() => {
  class UnsubscribeApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getOverview(r) {
      const request = r.toApiJson ? r : new GetOverviewRequest(r);
      return this.http.post(this._host + "/notifications.v1.Unsubscribe/GetOverview", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOverviewResponse.fromProto(resp)));
    }
    unsubscribe(r) {
      const request = r.toApiJson ? r : new UnsubscribeRequest(r);
      return this.http.post(this._host + "/notifications.v1.Unsubscribe/Unsubscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  UnsubscribeApiService.ɵfac = function UnsubscribeApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UnsubscribeApiService)();
  };
  UnsubscribeApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UnsubscribeApiService,
    factory: UnsubscribeApiService.ɵfac,
    providedIn: 'root'
  });
  return UnsubscribeApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnsubscribeService = /*#__PURE__*/(() => {
  class UnsubscribeService {
    constructor(api) {
      this.api = api;
    }
    getOverview$(token) {
      return this.api.getOverview({
        token
      });
    }
    unsubscribe$(token) {
      return this.api.unsubscribe({
        token
      });
    }
  }
  UnsubscribeService.ɵfac = function UnsubscribeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UnsubscribeService)(i0.ɵɵinject(UnsubscribeApiService));
  };
  UnsubscribeService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UnsubscribeService,
    factory: UnsubscribeService.ɵfac,
    providedIn: 'root'
  });
  return UnsubscribeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LegacyNotificationPreferenceApiService = /*#__PURE__*/(() => {
  class LegacyNotificationPreferenceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateResponse.fromProto(resp)));
    }
    bulkUpdate(r) {
      const request = r.toApiJson ? r : new BulkUpdateRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/BulkUpdate", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkUpdateResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/Delete", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeleteResponse.fromProto(resp)));
    }
    getAvailableSections(r) {
      const request = r.toApiJson ? r : new GetAvailableSectionsRequest(r);
      return this.http.post(this._host + "/notifications.v1.legacy.LegacyNotificationPreference/GetAvailableSections", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableSectionsResponse.fromProto(resp)));
    }
  }
  LegacyNotificationPreferenceApiService.ɵfac = function LegacyNotificationPreferenceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LegacyNotificationPreferenceApiService)();
  };
  LegacyNotificationPreferenceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LegacyNotificationPreferenceApiService,
    factory: LegacyNotificationPreferenceApiService.ɵfac,
    providedIn: 'root'
  });
  return LegacyNotificationPreferenceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LegacyNotificationPreferenceService = /*#__PURE__*/(() => {
  class LegacyNotificationPreferenceService {
    constructor(api) {
      this.api = api;
    }
    get$(partnerId, marketId, userId, businessId) {
      const req = {
        identifier: {
          partnerId,
          marketId,
          userId,
          businessId
        }
      };
      return this.api.get(req);
    }
    list$(partnerId, marketId, userId, businessId, cursor, pageSize) {
      const req = {
        partialIdentifier: {
          partnerId,
          marketId,
          userId,
          businessId
        },
        cursor,
        pageSize
      };
      return this.api.list(req);
    }
    update$(changes, partnerId, marketId, userId, businessId) {
      const req = {
        changes,
        identifier: {
          partnerId,
          marketId,
          userId,
          businessId
        }
      };
      return this.api.update(req);
    }
    delete$(partnerId, marketId, userId, businessId) {
      const req = {
        identifier: {
          partnerId,
          marketId,
          userId,
          businessId
        }
      };
      return this.api.delete(req);
    }
    //deprecated
    bulkUpdate$(changes, identifiers, partialIdentifiers) {
      const req = {
        changes,
        identifiers,
        partialIdentifiers
      };
      return this.api.bulkUpdate(req);
    }
    bulkUpdatePreferenceByIdentifier(changes, identifiers) {
      const req = {
        changes,
        identifiers
      };
      return this.api.bulkUpdate(req);
    }
    bulkUpdateBusinessByUser(changes, partnerId, userIds) {
      const req = {
        changes,
        businessByUser: {
          partnerId,
          userIds
        }
      };
      return this.api.bulkUpdate(req);
    }
    bulkUpdateBusinessByPartner(changes, partnerId) {
      const req = {
        changes,
        businessByPartner: {
          partnerId
        }
      };
      return this.api.bulkUpdate(req);
    }
    bulkUpdateUsersByPartner(changes, partnerId) {
      const req = {
        changes,
        userByPartner: {
          partnerId
        }
      };
      return this.api.bulkUpdate(req);
    }
    getAvailableSections(partnerId, marketId, businessId, locale, appIds) {
      const req = {
        partialIdentifier: {
          partnerId,
          marketId,
          businessId
        },
        locale,
        appIds
      };
      return this.api.getAvailableSections(req).pipe(map$1(resp => resp?.sections));
    }
  }
  LegacyNotificationPreferenceService.ɵfac = function LegacyNotificationPreferenceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LegacyNotificationPreferenceService)(i0.ɵɵinject(LegacyNotificationPreferenceApiService));
  };
  LegacyNotificationPreferenceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LegacyNotificationPreferenceService,
    factory: LegacyNotificationPreferenceService.ɵfac,
    providedIn: 'root'
  });
  return LegacyNotificationPreferenceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccessRequirement, ContentType, GetNotificationSettingsResponse, Hydrator, LegacyNotificationPreferenceService, Status as LegacyStatus, ListNotificationTypesResponse, ListNotificationsResponse, ListTypesResponse, MediumConfiguration, NotificationMedium, NotificationSetting$1 as NotificationSetting, NotificationStatus, NotificationType, NotificationTypeEmail, NotificationTypeWeb, NotificationTypeWebBundle, NotificationsAdminService, NotificationsService, PersonaType, UnsubscribeService, setAccessRequirement, setCategory, setDescription, setDomainId, setEmailContentTemplate, setEmailContentType, setEmailEnabled, setEmailFromAddressTemplate, setEmailFromNameTemplate, setEmailLinkTemplate, setEmailSample, setEmailServiceProvider, setEmailSubjectTemplate, setFeatureFlagId, setHydrators, setLocales, setName, setPersonaAccessRequirements, setWebBundleContentTemplate, setWebBundleEnabled, setWebBundleLinkTemplate, setWebBundleSample, setWebBundleWindow, setWebContentTemplate, setWebEnabled, setWebLinkTemplate, setWebSample };
